/**
 * Created by tomers on 3/1/2015.
 */
define(function (require) {
    "use strict";

    var Dialog = require("ui/dialog/Dialog");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var Media = require("media");
    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var AwayReasonsEditView = require("personalization-web-agent-views/AwayReasonsEditView");
    var AwayReasonEditItemDialogView = require("personalization-web-agent-views/away-reasons/AwayReasonEditItemDialogView");


    var AwayReasonsEditController = {};

    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {

        AwayReasonsEditController = BaseFeatureController.extend({
            initialize: function(options) {
                this._initialize(options);
            },

            getEditView: function() {
                return this._getEditView();
            },


            _initialize: function (options) {
                LEPersonalization.logger.info("initializing", "AwayReasonsEditController:_initialize");

                this.channel = Media.channel(LE.mediaCodes.personalization.channels.AWAY_REASONS);
                this.agentReasonsCollection = options.agentReasonsCollection;

                this._createView(options);
                this._bindEvents();
            },

            _createView: function(options) {
                LEPersonalization.logger.debug("create the edit view", "AwayReasonsEditController:_createView");

                this.awayReasonsEditView = new AwayReasonsEditView({
                    anchorSelector: options.featureOptions.anchorSelector,
                    collection: this.agentReasonsCollection
                });

                LEPersonalization.logger.debug("the created edit view", "AwayReasonsEditController:_createView", this.awayReasonsEditView);
            },

            _bindEvents: function() {
                LEPersonalization.logger.debug("binding events", "AwayReasonsEditController:_bindEvents");

                this.listenTo(this.channel, "awayReasons:list:new", this._onListNewReason);
                this.listenTo(this.channel, "awayReasons:list:edit", this._onListEditReason);
                this.listenTo(this.channel, "awayReasons:list:delete", this._onListDeleteReason);
                this.listenTo(this.channel, "awayReasons:list:done", this._onListDone);

                this.listenTo(this.channel, "awayReasons:dialog:change:text", this._onDialogTextChange);
                this.listenTo(this.channel, "awayReasons:dialog:save", this._onDialogSave);
                this.listenTo(this.channel, "awayReasons:dialog:cancel", this._onDialogCancel);


                // The "close" method in the controller is never triggered. In order to stop listening to the channel (in order to avoid double binding), we need to listen to the view closing
                this.listenTo(this.awayReasonsEditView, "close", this.stopListening);

            },

            _onListNewReason: function() {
                LEPersonalization.logger.info("new reason was clicked", "AwayReasonsEditController:_onListNewReason");
                this.awayReasonModel = new this.agentReasonsCollection.model();
                this._showDialog();
            },

            _onListEditReason: function(model) {
                LEPersonalization.logger.info("edit reason was clicked", "AwayReasonsEditController:_onListEditReason");
                this.awayReasonModel = new this.agentReasonsCollection.model({id:model.id});
                this._fetchModel();
            },

            _fetchModel: function() {
                LEPersonalization.logger.info("fetch model for editing", "AwayReasonsEditController:_fetchModel");
                LEPersonalization.loader.setLoader();
                this.awayReasonModel.fetch({
                    success: _.bind(this._onFetchSuccess, this),
                    error: _.bind(this._onFetchError, this)
                });
            },

            _onFetchSuccess: function() {
                LEPersonalization.loader.closeLoader();
                this._showDialog();
            },

            _onFetchError: function(model, response, options) {
                LEPersonalization.loader.closeLoader();
                var errorMsg = LE.translator.translate("LEFramework.something.went.wrong");
                if (response && response.responseError) {
                    if (response.responseError.message) {
                        errorMsg = response.responseError.message;
                    }

                    if (response.responseError.internalCode === ErrorCodes.noDataFound) {
                        errorMsg = LE.translator.translate("LEFramework.entities.agentReason.errors.already.deleted");
                    }
                }

                this._showGeneralError(errorMsg);
            },

            _showDialog: function() {
                LEPersonalization.logger.info("show dialog", "AwayReasonsEditController:_showDialog");

                this.awayReasonEditItemView = new AwayReasonEditItemDialogView({model:this.awayReasonModel});
                this.awayReasonEditItemDialog = new Dialog({
                    theme: Dialog.THEME.NIGHT,
                    innerView: this.awayReasonEditItemView,
                    moduleName: LEPersonalization.moduleName,
                    context: LE.context
                });

                this.channel.trigger("awayReasons:showDialog", this.awayReasonEditItemDialog);
            },

            _closeDialog: function() {
                LEPersonalization.logger.info("close dialog", "AwayReasonsEditController:_closeDialog");
                this.channel.trigger("awayReasons:closeDialog");
            },


            _onDialogTextChange: function(text) {
                LEPersonalization.logger.info("text change", "AwayReasonsEditController:_onDialogTextChange", text);

                this.awayReasonModel.setText(text);
            },

            _onDialogCancel: function() {
                LEPersonalization.logger.info("cancel was clicked in dialog", "AwayReasonsEditController:_onDialogCancel");
                this._closeDialog();
            },

            _onDialogSave: function() {
                LEPersonalization.logger.info("save was clicked in dialog", "AwayReasonsEditController:_onDialogSave");

                this.listenTo(this.awayReasonModel, "invalid", _.bind(this._onSaveInvalid, this));

                this.awayReasonEditItemDialog.showLoader({permutation:Dialog.LOADER_PERMUTATION.M});
                this.awayReasonModel.save(null, {
                    ignoreError: true,
                    success: _.bind(this._onSaveSuccess, this),
                    error: _.bind(this._onSaveError, this)
                });
            },

            _onSaveSuccess: function(model, response, options) {
                LEPersonalization.logger.info("reason was created", "AwayReasonsEditController:_onSaveSuccess");

                this.stopListening(this.awayReasonModel, "invalid");

                this._updateCollection(model, options);
                this._closeDialog();

                this.awayReasonEditItemDialog.closeLoader();
            },

            _onSaveError: function(model, response, options) {
                LEPersonalization.logger.debug("reason was not created - failed by server", "AwayReasonsEditController:_onSaveError");
                this.stopListening(this.awayReasonModel, "invalid");
                this.awayReasonEditItemDialog.closeLoader();

                var errorMsg = LE.translator.translate("LEFramework.something.went.wrong");
                if (response && response.responseError) {
                    if (response.responseError.message) {
                        errorMsg = response.responseError.message;
                    }

                    if (response.responseError.internalCode === ErrorCodes.uniquenessViolation) {
                        errorMsg = LE.translator.translate("LEFramework.entities.agentReason.errors.text.duplicated");
                        var errorObj = {};
                        errorObj[this.awayReasonModel.KEYS.TEXT] = "LEFramework.entities.agentReason.errors.text.duplicated";
                        this.awayReasonModel.trigger("invalid", this.awayReasonModel, errorObj);
                    } else if (response.responseError.internalCode === ErrorCodes.maxEntityLimitViolation) {
                        errorMsg = LE.translator.translate("LEFramework.entities.agentReason.errors.maxEntities");
                    } else if (response.responseError.internalCode === ErrorCodes.dependencyConflict) {
                        errorMsg = LE.translator.translate("LEFramework.entities.agentReason.errors.dependency.conflict");
                    }
                }

                this._showGeneralError(errorMsg);
            },

            _onSaveInvalid: function() {
                LEPersonalization.logger.debug("reason was not created - failed by validation", "AwayReasonsEditController:_onSaveInvalid");
                this.stopListening(this.awayReasonModel, "invalid");
                this.awayReasonEditItemDialog.closeLoader();
                this._showGeneralError(LE.translator.translate("LEFramework.errors.generalError.on.page"));
            },

            _onListDeleteReason: function(model) {
                LEPersonalization.logger.info("delete was clicked", "AwayReasonsEditController:_onListDeleteReason", model.id);
                LEPersonalization.notifier.showConfirm({
                    title: LE.translator.translate("LEPersonalization.webAgent.agentState.edit.awayReasons.delete.confirmation.title"),
                    content: LE.translator.translate("LEPersonalization.webAgent.agentState.edit.awayReasons.delete.confirmation.text"),
                    objectAction: {
                        text: LE.translator.translate("LEFramework.global.captions.yes"),
                        callback: _.bind(this._onDeleteConfirmed, this, model)
                    }
                });
            },

            _onDeleteConfirmed: function(model) {
                LEPersonalization.loader.setLoader();
                model.destroy({
                    success: _.bind(this._onDeleteSuccess, this),
                    error: _.bind(this._onDeleteError, this),
                    wait: true,
                    ignoreError: true
                });
            },

            _onDeleteSuccess: function(model, response, options) {
                LEPersonalization.logger.debug("reason was deleted", "AwayReasonsEditController:_onDeleteSuccess");
                LEPersonalization.loader.closeLoader();
            },

            _onDeleteError: function(model, response, options) {
                LEPersonalization.logger.error("reason was not deleted", "AwayReasonsEditController:_onDeleteError", response);
                LEPersonalization.loader.closeLoader();
                var errorMsg = LE.translator.translate("LEFramework.something.went.wrong");
                if (response && _.has(response, "responseError")){
                    if (_.has(response.responseError, "message")) {
                        errorMsg = response.responseError.message;
                    }
                    if (response.responseError.internalCode == ErrorCodes.noDataFound) {
                        errorMsg = LE.translator.translate("LEFramework.entities.agentReason.errors.already.deleted");
                    }
                    else if (response.responseError.internalCode == ErrorCodes.dependencyConflict) {
                        errorMsg = LE.translator.translate("LEFramework.entities.agentReason.errors.delete.conflict");
                    }
                }

                this._showGeneralError(errorMsg);
            },

            _onListDone: function() {
                LEPersonalization.logger.debug("done was clicked", "AwayReasonsEditController:_onListDone");
                LEPersonalization.navigateToPageMenu();
            },

            _showGeneralError: function(errorMsg) {
                if (errorMsg) {
                    LEPersonalization.notifier.showError({
                        content: errorMsg,
                        timeToShow: 6000
                    });
                }
            },

            _updateCollection: function(model, options) {
                options = options || {};
                options.merge = true;
                options.silent = false;
                this.agentReasonsCollection.add(model.toJSON(), options);
            },

            _getEditView: function () {
                return this.awayReasonsEditView;
            }
        });
    });
    return AwayReasonsEditController;

});
